import { Controller } from "stimulus";
import { showUploadItemDialog } from "./upload_item_dialog_controller";

export default class extends Controller {
  openDialog() {
    showUploadItemDialog();
  }
}
